import type { Video } from '../services/api';
import { getDisplayedVideoStatus } from './runScopedVideoStatus';

export type VideoSortField = 'date' | 'name' | 'status';

const STATUS_ORDER: Record<string, number> = {
  not_processed: 0,
  processing: 1,
  processed: 2,
  failed: 3,
};

/** Shared gallery ordering; never mutates membership or selected IDs. */
export const sortVideos = (
  videos: Video[], field: VideoSortField, ascending: boolean,
  displayStatus: (video: Video) => string = getDisplayedVideoStatus,
): Video[] => (
  [...videos].sort((a, b) => {
    const comparison = field === 'name'
      ? a.title.localeCompare(b.title)
      : field === 'date'
        ? new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        : (STATUS_ORDER[displayStatus(a)] || 0) - (STATUS_ORDER[displayStatus(b)] || 0);
    return ascending ? comparison : -comparison;
  })
);
